import CONFIG from '$config'

export const profile = process.env.PROFILE || CONFIG?.PROFILE || 'local'

export const isLocalProfile = profile === 'local'
export const isDevProfile = profile === 'dev'
export const isTestProfile = profile === 'test'
export const isAlphaProfile = profile === 'alpha'
export const isStageProfile = profile === 'stage'
export const isRealProfile = profile === 'real'

export const isOpenProfile = isRealProfile || isStageProfile
